export const unidadesRegionaisMenu = {
    name: 'Unidades Regionais',
    url: '/appsebrae/consultorias/unidadesregionais',
    icon: 'fa fa-building-o',
    regras: ['APPSE-CONS-UR-00']
}